module.exports = __webpack_public_path__ + "img/edit.7cae5a01.svg";